import React, { useState, useEffect } from 'react';
import './App.css';

// ── Inline SVG Icons ─────────────────────────────────────────────────────────
const ShoppingCart = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);
const Menu = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);
const X = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const Download = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
const Shield = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const CreditCard = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const InfinityIcon = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 12c-2-2.5-4-4-6-4a4 4 0 0 0 0 8c2 0 4-1.5 6-4z" />
    <path d="M12 12c2 2.5 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.5-6 4z" />
  </svg>
);
const Star = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const Instagram = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);
const Facebook = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);
const Twitter = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
  </svg>
);
// ─────────────────────────────────────────────────────────────────────────────

export default function App() {
  const [cartCount, setCartCount] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const addToCart = () => setCartCount(c => c + 1);

  return (
    <div className="app">
      <Navbar cartCount={cartCount} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <Hero />
      <Products addToCart={addToCart} />
      <Collections />
      <Pricing />
      <Features />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

// ── Navbar ────────────────────────────────────────────────────────────────────
function Navbar({ cartCount, mobileMenuOpen, setMobileMenuOpen }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <div className="navbar__inner">
        <div className="navbar__logo">WALLCANVASCO</div>

        <div className="navbar__links">
          <a href="#home"        className="navbar__link">Home</a>
          <a href="#shop"        className="navbar__link">Shop</a>
          <a href="#collections" className="navbar__link">Collections</a>
          <a href="#pricing"     className="navbar__link">Pricing</a>
          <a href="#contact"     className="navbar__link">Contact</a>
        </div>

        <div className="navbar__actions">
          <div className="navbar__cart">
            <ShoppingCart className="navbar__cart-icon" />
            {cartCount > 0 && (
              <span className="navbar__cart-badge">{cartCount}</span>
            )}
          </div>
          <button className="btn btn--primary">Buy Now</button>
        </div>

        <button
          className="navbar__hamburger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X className="icon" /> : <Menu className="icon" />}
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="navbar__mobile">
          <a href="#home"        className="navbar__mobile-link" onClick={() => setMobileMenuOpen(false)}>Home</a>
          <a href="#shop"        className="navbar__mobile-link" onClick={() => setMobileMenuOpen(false)}>Shop</a>
          <a href="#collections" className="navbar__mobile-link" onClick={() => setMobileMenuOpen(false)}>Collections</a>
          <a href="#pricing"     className="navbar__mobile-link" onClick={() => setMobileMenuOpen(false)}>Pricing</a>
          <a href="#contact"     className="navbar__mobile-link" onClick={() => setMobileMenuOpen(false)}>Contact</a>
          <button className="btn btn--primary btn--full">Buy Now</button>
        </div>
      )}
    </nav>
  );
}

// ── Hero ──────────────────────────────────────────────────────────────────────
function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero__bg">
        <div className="hero__pattern" />
      </div>
      <div className="hero__content">
        <p className="hero__eyebrow">✦ Premium Digital Art Studio</p>
        <h1 className="hero__title">
          Elevate Your Space<br />
          <span className="hero__title-accent">Premium Canvas Art</span>
        </h1>
        <p className="hero__subtitle">
          Modern, high-quality designs instantly available — transform any room into a masterpiece.
        </p>
        <div className="hero__actions">
          <a href="#shop"        className="btn btn--primary btn--lg">Shop Now</a>
          <a href="#collections" className="btn btn--outline btn--lg">Explore Collection</a>
        </div>
        <div className="hero__stats">
          <div className="hero__stat"><span className="hero__stat-num">500+</span><span className="hero__stat-label">Designs</span></div>
          <div className="hero__stat-divider" />
          <div className="hero__stat"><span className="hero__stat-num">12k+</span><span className="hero__stat-label">Customers</span></div>
          <div className="hero__stat-divider" />
          <div className="hero__stat"><span className="hero__stat-num">4.9★</span><span className="hero__stat-label">Rating</span></div>
        </div>
      </div>
    </section>
  );
}

// ── Product Card ──────────────────────────────────────────────────────────────
function ProductCard({ product, addToCart }) {
  return (
    <div className="product-card">
      <div className="product-card__image">
        <img src={product.img} alt={product.title} className="product-card__img" />
        <div className="product-card__image-overlay" />
        <span className="product-card__badge">HD</span>
      </div>
      <div className="product-card__body">
        <h3 className="product-card__title">{product.title}</h3>
        <p  className="product-card__desc">{product.description}</p>
        <div className="product-card__footer">
          <span className="product-card__price">{product.price}€</span>
          <button onClick={addToCart} className="btn btn--primary btn--sm">Add to Cart</button>
        </div>
      </div>
    </div>
  );
}

// ── Products Section ──────────────────────────────────────────────────────────
function Products({ addToCart }) {
  const products = [
    { id: 1, title: 'Golden Abstract',  description: 'Luxury gold patterns',    price: 49,  img: '/product_golden_abstract.png' },
    { id: 2, title: 'Midnight Dreams',  description: 'Deep blue elegance',      price: 39,  img: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=600&q=80' },
    { id: 3, title: 'Marble Essence',   description: 'Modern marble art',       price: 59,  img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80' },
    { id: 4, title: 'Crimson Flow',     description: 'Bold red design',         price: 45,  img: 'https://images.unsplash.com/photo-1541701494587-cb58502866ab?w=600&q=80' },
    { id: 5, title: 'Emerald Vista',    description: 'Rich green tones',        price: 55,  img: 'https://images.unsplash.com/photo-1518173946687-a4c8892bbd9f?w=600&q=80' },
    { id: 6, title: 'Silver Waves',     description: 'Metallic shimmer',        price: 49,  img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80' },
    { id: 7, title: 'Rose Gold',        description: 'Elegant pink gold',       price: 65,  img: 'https://images.unsplash.com/photo-1470813740244-df37b8c1edcb?w=600&q=80' },
    { id: 8, title: 'Ocean Depth',      description: 'Deep blue tranquility',   price: 42,  img: 'https://images.unsplash.com/photo-1505118380757-91f5f5632de0?w=600&q=80' },
  ];

  return (
    <section id="shop" className="products">
      <div className="section-container">
        <div className="section-heading">
          <h2>Premium Collection</h2>
          <p>Handpicked designs for your luxury space</p>
        </div>
        <div className="products__grid">
          {products.map(p => (
            <ProductCard key={p.id} product={p} addToCart={addToCart} />
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Collections ───────────────────────────────────────────────────────────────
function Collections() {
  const collections = [
    { name: 'Abstract',      img: '/collection_abstract.png'      },
    { name: 'Luxury Gold',   img: '/collection_luxury_gold.png'   },
    { name: 'Minimal Black', img: '/collection_minimal_black.png' },
    { name: 'Modern Art',    img: '/collection_modern_art.png'    },
  ];

  return (
    <section id="collections" className="collections">
      <div className="section-container">
        <div className="section-heading">
          <h2>Explore Collections</h2>
          <p>Curated themes for every style</p>
        </div>
        <div className="collections__grid">
          {collections.map((c, i) => (
            <div key={i} className="collection-item">
              {/* Background image */}
              <img
                src={c.img}
                alt={c.name}
                className="collection-item__img"
              />
              {/* Dark overlay */}
              <div className="collection-item__overlay" />
              {/* Hover glow */}
              <div className="collection-item__glow" />
              {/* Text content */}
              <div className="collection-item__content">
                <h3 className="collection-item__name">{c.name}</h3>
                <span className="collection-item__cta">Browse →</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Pricing ───────────────────────────────────────────────────────────────────
function Pricing() {
  const plans = [
    { name: 'Basic',    price: 29,  highlight: false, features: ['1 Canvas Design',  'HD Quality',      'Instant Download', 'Personal Use']                                        },
    { name: 'Standard', price: 49,  highlight: true,  features: ['3 Canvas Designs', '4K Ultra HD',     'Instant Download', 'Commercial Use',       'Lifetime Updates']             },
    { name: 'Premium',  price: 69,  highlight: false, features: ['5 Canvas Designs', '4K Ultra HD',     'Priority Support', 'Commercial Use',       'Exclusive Designs']            },
    { name: 'Ultimate', price: 129, highlight: false, features: ['10 Canvas Designs','8K Resolution',   'VIP Support',      'Full Commercial Rights','Custom Requests']              },
  ];

  return (
    <section id="pricing" className="pricing">
      <div className="section-container">
        <div className="section-heading">
          <h2>Simple Pricing</h2>
          <p>Choose the perfect plan for your needs</p>
        </div>
        <div className="pricing__grid">
          {plans.map((plan, i) => (
            <div key={i} className={`pricing-card${plan.highlight ? ' pricing-card--highlight' : ''}`}>
              {plan.highlight && <span className="pricing-card__tag">Most Popular</span>}
              <h3 className="pricing-card__name">{plan.name}</h3>
              <div className="pricing-card__price">
                <span className="pricing-card__amount">{plan.price}€</span>
                <span className="pricing-card__period">/one-time</span>
              </div>
              <ul className="pricing-card__features">
                {plan.features.map((f, j) => (
                  <li key={j} className="pricing-card__feature">
                    <span className="pricing-card__check">✓</span>
                    {f}
                  </li>
                ))}
              </ul>
              <button className={`btn btn--full${plan.highlight ? ' btn--primary' : ' btn--ghost'}`}>
                Get Started
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Features ──────────────────────────────────────────────────────────────────
function Features() {
  const features = [
    { icon: <Download className="feature-icon" />, title: 'Instant Download',  description: 'Get your art immediately after purchase'     },
    { icon: <Shield   className="feature-icon" />, title: '4K Ultra HD',       description: 'Crystal clear quality for any display size'   },
    { icon: <CreditCard className="feature-icon"/>, title: 'Secure Payment',    description: 'Safe & encrypted checkout every time'         },
    { icon: <InfinityIcon className="feature-icon"/>,title:'Lifetime Access',   description: 'Download your files anytime, forever'         },
  ];

  return (
    <section className="features">
      <div className="section-container">
        <div className="section-heading">
          <h2>Why Choose Us</h2>
          <p>Everything you need from a premium art studio</p>
        </div>
        <div className="features__grid">
          {features.map((f, i) => (
            <div key={i} className="feature-item">
              <div className="feature-item__icon-wrap">{f.icon}</div>
              <h3 className="feature-item__title">{f.title}</h3>
              <p  className="feature-item__desc">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Testimonials ──────────────────────────────────────────────────────────────
function Testimonials() {
  const testimonials = [
    { name: 'Sarah M.',   rating: 5, text: 'Absolutely stunning quality! Transformed my living room completely.'        },
    { name: 'James L.',   rating: 5, text: 'Best investment for my office. Clients always comment on the art.'          },
    { name: 'Emma R.',    rating: 5, text: 'The download was instant and the quality exceeded expectations!'             },
    { name: 'Michael K.', rating: 5, text: 'Professional service and beautiful designs. Highly recommend!'              },
  ];

  return (
    <section className="testimonials">
      <div className="section-container">
        <div className="section-heading">
          <h2>What Clients Say</h2>
          <p>Trusted by thousands worldwide</p>
        </div>
        <div className="testimonials__grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <div className="testimonial-card__stars">
                {[...Array(t.rating)].map((_, j) => (
                  <Star key={j} className="star-icon" />
                ))}
              </div>
              <p className="testimonial-card__text">"{t.text}"</p>
              <p className="testimonial-card__author">— {t.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Contact ───────────────────────────────────────────────────────────────────
function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="section-container">
        <div className="section-heading">
          <h2>Get In Touch</h2>
          <p>Have questions? We'd love to hear from you</p>
        </div>
        <form className="contact__form">
          <div className="form-group">
            <input type="text"  placeholder="Your Name"    className="form-input" />
          </div>
          <div className="form-group">
            <input type="email" placeholder="Your Email"   className="form-input" />
          </div>
          <div className="form-group">
            <textarea rows="5"  placeholder="Your Message" className="form-input form-input--textarea" />
          </div>
          <button type="submit" className="btn btn--primary btn--full btn--lg">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}

// ── Footer ────────────────────────────────────────────────────────────────────
function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <h2 className="footer__logo">WALLCANVASCO</h2>
          <p className="footer__desc">
            Premium digital wall art and canvas designs for modern spaces.
          </p>
          <p className="footer__notice">⚠️ Digital products only – no physical shipping</p>
        </div>

        <div className="footer__col">
          <h3 className="footer__col-title">Quick Links</h3>
          <ul className="footer__links">
            <li><a href="#shop"        className="footer__link">Shop</a></li>
            <li><a href="#collections" className="footer__link">Collections</a></li>
            <li><a href="#pricing"     className="footer__link">Pricing</a></li>
            <li><a href="#contact"     className="footer__link">Contact</a></li>
          </ul>
        </div>

        <div className="footer__col">
          <h3 className="footer__col-title">Follow Us</h3>
          <div className="footer__social">
            <a href="#" className="social-icon" aria-label="Instagram"><Instagram className="icon" /></a>
            <a href="#" className="social-icon" aria-label="Facebook"><Facebook  className="icon" /></a>
            <a href="#" className="social-icon" aria-label="Twitter"><Twitter    className="icon" /></a>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© 2024 WALLCANVASCO. All rights reserved.</p>
      </div>
    </footer>
  );
}